
<template>
    <div class="app-pages" id="pages" :style="{'height': pagesMaxHeight + 'px'}">
        <div class="usage-headers" ref="usageHeaders">
            <div class="selects">
                <div class="fl selects-area" @click="changeModel(1)">
                    <SelectArea :defaultValue="selectArea.selectAreaName"> </SelectArea>
                </div>
                <div class="fr  selects-date" @click="changeModel(2)">
                    <selectDate :value='showSelectDateValue'></selectDate>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
        <div class="rolling-table app-table" ref="tableBox" :style="{'height': maxHeight + 'px'}">
            <table class="table" id="table" cellpadding="0" cellspacing="0" ref="rollingTable">
                <tr v-for="(x,i) in xList" :key="i">
                    <th class="rows " :class="{'cross': index == 0 && i == 0}" v-for="(l,index) in x" :key="l.field_name" :colspan="l.colspan" :rowspan="l.rowspan">{{l.name}}</th>
                </tr>
                <tr v-if="!yList.length">
                    <td class="cols" colspan="1">&nbsp;</td>
                    <td colspan="13">暂无数据</td>
                </tr>
                <tr v-for="(l,i) in yList" :key="i + 'a'">
                    <template v-for="(x, xKey) in xField">
                        <td v-for="(ll, yKey) in l" :key="yKey" v-if="x === yKey" :class="{'cols': yKey == xField[0]}">
                            {{ yList[i][yKey] }}
                        </td>
                    </template>
                </tr>
                <tr></tr>
            </table>
        </div>
        <ModelArea :defaultId="areaId" :showModel="showModel" @hide="changeHideModel" @ok="submitModel"></ModelArea>
        <ModelDate :dateValue="dafaultDate" :isNeedDay="isNeedDay" :endDate="dafaultDate" :showModel="showModelDate" @hide="changeHideModel" @ok="submitDateModel"></ModelDate>
    </div>
</template>
<script>
import { createIScrollerAuto } from "libs/iscrollTable";
import { formatDateTime, formatDateTimeReg } from "libs/common/common";
import { Toast, Indicator } from "mint-ui";
import ModelArea from "com/app/appUsage/appModelArea.vue";
import ModelDate from "com/app/appUsage/appModelDate.vue";
import SelectArea from "com/app/appUsage/selectArea.vue";
import selectDate from "com/app/appUsage/selectDate.vue";
import commonMixin from 'mixins/common/common.js';
export default {
    components: {
        ModelArea,
        ModelDate,
        SelectArea,
        selectDate
    },
    mixins: [commonMixin],
    data() {
        return {
            // 选择的地区
            selectArea: {
                isSelectArea: false, //是否选择了区
                selectCityId: '', //选择了市的id
                selectAreaId: '', //选择了区的id
                selectAreaName: '' //选择了的地区的名字
            },
            showSelectDateValue: this.getYesday(2),
            selectDateValue: "", //头部选择的日期
            activeDate: new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 1)),
            dafaultDate: new Date(new Date(new Date().getTime() - 24 * 60 * 60 * 1000 * 1)),//前一天
            // 是否展示地区选择 model
            showModel: false,
            // 是否展示日期选择 model
            showModelDate: false,
            // 日期选择 model  是否需要展示 日
            isNeedDay: true,
            // 请求的 id
            areaId: "0",
            //指标类型
            type: this.$route.query.type ? String(this.$route.query.type).toUpperCase() : "",
            scroll: {
                scroller: null
            },
            maxHeight: '100%',
            pagesMaxHeight: '',
            offsetHeight: 0,
            th: [],
            tl: [],
            temp: [],
            xList: [
                [
                    {
                        field_name: "area_name",
                        name: "地市/区县",
                        colspan: 1, //指定单元格 横向 跨越的 列数
                        rowspan: 1, //指定单元格 纵向 跨越的 行数
                    },
                    {
                        field_name: "m_count",
                        name: "登录手机经分APP人数",
                        colspan: 1,  //指定单元格 横向 跨越的 列数
                        rowspan: 1, //指定单元格 纵向 跨越的 行数
                    },
                    {
                        field_name: "y_count",
                        name: "有效使用人数	",
                        colspan: 1,
                        rowspan: 1,
                    },
                    {
                        field_name: "cnt_usr",
                        name: "经分账号人数",
                        colspan: 1,
                        rowspan: 1,
                    },
                    {
                        field_name: "rate_1",
                        name: "手机经分登陆率%",
                        colspan: 1,
                        rowspan: 1,
                    },
                    {
                        field_name: "pm_1",
                        name: "排名",
                        colspan: 1,
                        rowspan: 1,
                    },
                    {
                        field_name: "rate_2",
                        name: "有效使用率%",
                        colspan: 1,
                        rowspan: 1,
                    },
                    {
                        field_name: "pm_2",
                        name: "排名",
                        colspan: 1,
                        rowspan: 1,
                    },
                    {
                        field_name: "pc_usr",
                        name: "近三月登陆过PC端大数据平台用户数",
                        colspan: 1,
                        rowspan: 1,
                    },
                    {
                        field_name: "rate_3",
                        name: "其中：手机经分登陆率%",
                        colspan: 1,
                        rowspan: 1,
                    },
                    {
                        field_name: "pm_3",
                        name: "排名",
                        colspan: 1,
                        rowspan: 1,
                    },
                    {
                        field_name: "g_count",
                        name: "功能点点击数",
                        colspan: 1,
                        rowspan: 1,
                    },
                    {
                        field_name: "pm_4",
                        name: "排名",
                        colspan: 1,
                        rowspan: 1,
                    },
                ],
            ],
            xField: ['area_name', 'm_count', "y_count", "cnt_usr", "rate_1", "pm_1", "rate_2", "pm_2", "pc_usr", "rate_3", "pm_3", "g_count", "pm_4",],
            yList: []
        }
    },
    computed: {
        // 用户信息
        userInfo() {
            this.areaId = this.$store.state.userInfo.aid;
            return this.$store.state.userInfo;
        },
    },
    watch: {
        userInfo() {
            this.selectArea.selectAreaName = this.$store.state.userInfo.area;
            this.getData(this.getYesday(1), this.areaId)
        },
    },
    filters: {
        valueFromt: function (value) {
            let realValue = ''
            if (!value) return ''
            value = value.toString()
            if (value.length > 20) {
                realValue = value.slice(0, 15) + '...'
            } else {
                realValue = value
            }
            return realValue
        },
    },
    methods: {
        getYesday(type) {
            let activeDate = new Date()
            let preDate = new Date(
                activeDate.getTime() - 24 * 60 * 60 * 1000 * 1
            );
            // 因为 preDate 已经是时间戳,所以要转换为 时间对象
            let newDate = new Date(preDate);
            let date = ''
            if (type == 1) {
                date = formatDateTimeReg(newDate, "YYYY-MM-DD mm:ss").slice(0, 8);
            } else {
                date = formatDateTime(newDate, "YYYY-MM-DD mm:ss").slice(0, 10);
            }
            return date
        },
        getData(date, id) {
            Indicator.open();
            this.$http.post(this.$urls.appUsage, {
                area_id: Number(id),
                date: Number(date)
                // date: 20180721
            })
                .then(res => {
                    Indicator.close();
                    if (res.data.code === 200) {
                        this.yList = res.data.data
                        if (this.yList.length) {
                            let date = this.yList[0].statis_date.toString()
                            let [year, month, day] = [date[0] + date[1] + date[2] + date[3], date[4] + date[5], date[6] + date[7]];
                            this.showSelectDateValue = year + "-" + month + "-" + day;
                        }
                    } else {
                        Toast(res.data.message);
                    }
                })
                .catch(error => {
                    Toast("获取数据失败");
                    Indicator.close();
                    console.log(error);
                });
        },
        // 选择的日期改变的时候
        getDates() {
            let date = formatDateTimeReg(this.activeDate, "YYYY-MM-DD mm:ss");
            date = date.slice(0, 8);
            console.log("date:", date)
            console.log("this.areaId:", this.areaId)
            this.getData(date, this.areaId);
        },
        // 根据地区修改来变更数据
        getDataBySelectArea() {
            // 等级 用于区分能下钻几层 ，0 是省，1 是市，2 是县或者分公司
            // 选择到省
            if (this.userInfo.level == 0 && !this.selectArea.selectCityId && !this.selectArea.selectAreaId) {
                this.areaId = 0;
                this.getDates();
            } else if (this.userInfo.level == 0 && this.selectArea.selectCityId && this.selectArea.selectAreaId) {
                // 选择到区
                this.areaId = this.selectArea.selectAreaId;
                this.getDates();
            } else if (this.userInfo.level == 0 && this.selectArea.selectCityId && !this.selectArea.selectAreaId) {
                // 选择到市
                this.areaId = this.selectArea.selectCityId;
                this.getDates();
            } else if (this.userInfo.level == 1 && this.selectArea.selectAreaId) {
                // 选择到区
                this.areaId = this.selectArea.selectAreaId;
                this.getDates();
            } else if (this.userInfo.level == 1 && !this.selectArea.selectAreaId && this.selectArea.selectCityId) {
                // 选择到市
                this.areaId = this.selectArea.selectCityId;
                this.getDates();
            }
        },
        changeModel(type) {
            if (type == 1) {
                if (this.userInfo.level < 2) {
                    this.showModel = true;
                } else {
                    Toast("您的账号权限有限！不可查看其他地区的信息！");
                }
            } else {
                this.showModelDate = true;
            }
        },
        // 提交 地区
        submitModel(data) {
            this.selectArea = data
            this.getDataBySelectArea();
        },
        // 提交日期
        submitDateModel(date) {
            this.showModelDate = false;
            this.showSelectDateValue = formatDateTime(date, "YYYY-MM-DD mm:ss").slice(0, 10);
            this.activeDate = date
            this.getDates()
        },
        changeHideModel(type) {
            if (type == 1) {
                this.showModel = false;
            } else {
                this.showModelDate = false;
            }
        },
    },
    created() { },
    mounted() {
        //判断是否是安卓还是ios
        function isAndroidOrIos() {
            var u = navigator.userAgent, app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            return isAndroid == true ? true : false;
        }
        this.offsetHeight = this.$refs.usageHeaders.offsetHeight
        // 因为 ios 我的应用里面用了旧的 webview 的原因，有高度获取不对的兼容性问题
        let androidHeight = window.screen.height - this.offsetHeight - (window.screen.availHeight - window.innerHeight)
        let iosHeight = window.screen.height - this.offsetHeight - (window.screen.availHeight - window.innerHeight) - 40
        this.maxHeight = isAndroidOrIos() ? androidHeight : iosHeight
        // this.maxHeight = isAndroidOrIos() ? androidHeight : androidHeight

        this.pagesMaxHeight = window.innerHeight
        this.scroll.scroller = createIScrollerAuto(".app-table");

    }
}

</script>
<style lang="less" scoped>
.app-pages{
    -webkit-overflow-scrolling: touch; // ios滑动顺畅
    // position: relative;
    overflow: auto;
}
.usage-headers {
    width: 100%;
    background-color: #fff;
    padding: 0.1rem 0;
    .selects {
        height: 0.8rem;
        font-size: 0.3rem;
        margin-top: 0.2rem;
        .selects-area,
        .selects-date {
            width: 3.3rem;
        }
        .selects-area {
            margin-left: 0.3rem;
        }
        .selects-date {
            margin-right: 0.3rem;
        }
    }

}
.rolling-table {
    -webkit-overflow-scrolling: touch; // ios滑动顺畅
    // height: 100%;
    font-size: 0.28rem;
    color: #86939a;
    background-color: #fff;
    width: 100%;
    position: relative;
    top: 0;
    overflow: hidden;
}
.rows {
    position: relative;
    z-index: 3;
}
.cross {
    position: relative;
    z-index: 5;
}
table td {
  border: 0px solid #000;
  font-size: 0.32rem;
  background: #fff;
}
::-webkit-scrollbar {
    display: none;
}
.table {
  -webkit-overflow-scrolling: touch; // ios滑动顺畅
  color: #86939e;
  font-size: 0.32rem;
  border: 0px solid #000;
  min-height: 100%;
  text-align: center;
    //   border-bottom: 0.02rem solid red;
  td {
    border-bottom: 0.02rem solid #eee;
    height: 0.86rem;
    line-height: 0.86rem;
    padding: 0 0.2rem;
    white-space: nowrap;
  }
  th {
    color: #43484d;
    white-space: nowrap;
    height: 0.9rem;
    line-height: 0.9rem;
    padding: 0rem 0.3rem;
    background-color: #f3f4f6;
    font-weight: normal;
    padding-bottom: 0;
    padding-top: 0;
    border-right: 0.02rem solid #eee;
    &:last-child{
        border-right: 0rem solid #e4e8f5;
    }
  }
}
tr{
    position: relative;
    background-color: #fff;
    &:nth-of-type(odd){
        td{
            background-color: #ebf9fc;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/app/appUsage.vue